import '@babel/polyfill';
import 'url-search-params-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/App';
import registerServiceWorker from './registerServiceWorker';
import Store from './registerIDBWorker';

import './styles/index.scss';

const DB_VERSION = 35;

ReactDOM.render(<App />, document.getElementById('root'));

registerServiceWorker();

new Store(DB_VERSION);



// WEBPACK FOOTER //
// ./src/index.js